/**
 * External dependencies
 */
import React from "react";
import { Box, Stack, Heading } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const Configuration = ({ children, title }) => {
  return (
    <Box className="report-builder__chart-configuration" marginTop="large">
      <Box marginBottom="medium">
        <Heading level={4}>{title}</Heading>
      </Box>
      <Stack space="xlarge">{children}</Stack>
    </Box>
  );
};

export default Configuration;
